import { getUserInfo } from '@/api/userCenter'
import { setToken, getToken, removeToken } from '@/utils/auth'
import { setCache, getCache, removeCache, setLocal, getLocal, removeLocal } from '@/utils/cache'
import { userLogin, getOAuthInfo } from '@/api/user'

// 用户信息存储模块
const getDefaultState = () => {
	return {
		userInfo: {},
		userId: getCache('cjt_user_id'),
		// 用户类型, 2: 企业账号，4: 个人账号
		userType: null,
		realName: '',
		phone: '',
		roles: [],
		token: getToken(),
		sessionId: getLocal('cjt_unified_auth_session_id') || '',
		userUnreadMessageCount: 0, // 用户未读消息数量
		unreadWarning: 0
	}
}

const state = getDefaultState()

const mutations = {
	SET_USERINFO: (state, userInfo) => {
		state.userInfo = userInfo
	},
	SET_USER_TYPE: (state, userType) => {
		state.userType = userType
	},
	SET_REALNAME: (state, realName) => {
		state.realName = realName
	},
	SET_ROLES: (state, roles) => {
		state.roles = roles
	},
	SET_TOKEN: (state, token) => {
		state.token = token
	},
	SET_SESSION_ID: (state, sessionId) => {
		state.sessionId = sessionId
	},
	SET_USER_ID: (state, userId) => {
		state.userId = userId
	},
	SET_PHONE: (state, phone) => {
		state.phone = phone
	},
	SET_UNREAD_MESSAGE_COUNT: (state, count) => {
		state.userUnreadMessageCount = count
	},
	SET_UNREAD_WARNING: (state, count) => {
		state.unreadWarning = count
	}
}
const actions = {
	setUserInfo({ commit }, userInfo) {
		commit('SET_USERINFO', userInfo)
	},
	setRoles({ commit }, roles) {
		commit('SET_ROLES', roles)
	},
	setToken({ commit }, token) {
		commit('SET_TOKEN', token)
	},
	setSessionId({ commit }, sessionId) {
		commit('SET_SESSION_ID', sessionId)
	},
	resetState({ commit }) {
		commit('SET_USERINFO', {})
		commit('SET_ROLES', [])
		commit('SET_TOKEN', '')
		commit('SET_SESSION_ID', '')
		commit('merchantShop/RESET_STATE', null, { root: true })
	},
	setUnreadMessageCount({ commit }, count) {
		commit('SET_UNREAD_MESSAGE_COUNT', count)
	},
	setUnreadWarning({ commit }, count) {
		commit('SET_UNREAD_WARNING', count)
	},
	// 用户登录
	login({ commit }, userInfo) {
		return new Promise((resolve, reject) => {
			userLogin(userInfo)
				.then(response => {
					const { data } = response
					commit('SET_TOKEN', data.token)
					commit('SET_USER_ID', data.userId)
					commit('SET_SESSION_ID', '')
					setToken(data.token)
					setCache('cjt_user_id', data.userId)
					removeLocal('cjt_unified_auth_session_id')
					resolve()
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	// 统一身份认证登录：使用认证平台回调令牌换取楚建通登录态
	unifiedAuthLogin({ commit, dispatch }, authParams) {
		return new Promise((resolve, reject) => {
			commit('SET_SESSION_ID', authParams.sessionId || '')
			setLocal('cjt_unified_auth_session_id', authParams.sessionId || '')

			getOAuthInfo(authParams)
				.then(async response => {
					const { data } = response
					const loginToken = data.token
					const userId = data.userId

					commit('SET_TOKEN', loginToken)
					setToken(loginToken)
					if (userId) {
						commit('SET_USER_ID', userId)
						setCache('cjt_user_id', userId)
					}

					resolve(data)
				})
				.catch(error => {
					commit('SET_TOKEN', '')
					commit('SET_SESSION_ID', '')
					removeToken()
					removeLocal('cjt_unified_auth_session_id')
					reject(error)
				})
		})
	},
	//  获取用户信息
	getUserInfo({ commit, state, dispatch }) {
		return new Promise((resolve, reject) => {
			getUserInfo()
				.then(async response => {
					const { data } = response
					commit('SET_REALNAME', data.realName)
					commit('SET_PHONE', data.phone)
					commit('SET_USERINFO', data)
					commit('SET_USER_TYPE', data.sysUserVO.userType)
					commit('enterprise/SET_COMPANY_ID', data.companyId, { root: true })
					await dispatch('enterprise/setCompany', data.companyId, { root: true })
					await dispatch('enterprise/setCompanyAdmin', data.enterpriseAdmin, { root: true })
					if (data.memberRecordList.length > 0) {
						// 从权益列表中取出会员等级
						const memberGrade = data.memberRecordList[0].memberGrade
						await dispatch('vip/setVipLevel', memberGrade, { root: true })
					}
					resolve()
				})
				.catch(error => {
					reject(error)
				})
		})
	},

	// 退出登录
	logout({ commit }) {
		return new Promise((resolve, reject) => {
			removeToken() // must remove  token  first
			removeCache('cjt_user_id')
			removeCache('cjt_unified_auth_session_id')
			commit('SET_USERINFO', {})
			commit('SET_REALNAME', '')
			commit('SET_ROLES', [])
			commit('SET_TOKEN', '')
			commit('SET_USER_ID', '')
			commit('SET_SESSION_ID', '')
			commit('merchantShop/RESET_STATE', null, { root: true })
			resolve()
		})
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
